import { DragStartEvent } from '@dnd-kit/core';
import { Dispatch, SetStateAction } from 'react';
import { WorkOrder } from '@models';

const isWorkOrderDraggable = (w: WorkOrder) => {
  if (!['POZ', 'NOV', 'NAP'].includes(w.currentState?.code ?? '')) return false;
  if (w.locked) return false;
  return true;
};

export function useDragStart({
  setMovingWorkOrders,
}: {
  setMovingWorkOrders: Dispatch<SetStateAction<WorkOrder[]>>;
}) {
  return (event: DragStartEvent) => {
    const workOrders = event.active.data.current as WorkOrder[];

    setMovingWorkOrders(workOrders.filter(isWorkOrderDraggable));
  };
}
